"use client";

import React from "react";
import HeroSection from "@/app/[locale]/main/component/HeroSection";
import VisionSection from "@/app/[locale]/main/component/VisionSection";
import EchoCycleSection from "@/app/[locale]/main/component/EchoCycleSection";
import LogisticSection from "@/app/[locale]/main/component/LogisticSection";
import SolutionSummerySection from "@/app/[locale]/main/component/SolutionSummerySection";
import CompanyHistorySection from "@/app/[locale]/main/component/CompanyHistorySection";
import NewsRoomSection from "@/app/[locale]/main/component/NewsRoomSection";
import CompanyHeadSection from "@/app/[locale]/main/component/CompanyHeadSection";
import LocationSection from "@/app/[locale]/main/component/LocationSection";
import PatentSection from "@/app/[locale]/main/component/PatentSection";
import ImpactCountSection from "@/app/[locale]/main/component/ImpactCountSection";
import {useSelector} from "react-redux";

const sections = [
    HeroSection,
    VisionSection,
    ImpactCountSection,
    EchoCycleSection,
    LogisticSection,
    SolutionSummerySection,
    CompanyHistorySection,
    PatentSection,
    NewsRoomSection,
    CompanyHeadSection,
    LocationSection,
];

const HomeClient = () => {
    const langData = useSelector(state => state.language.data);
    return (
        <>
            {
                langData &&
                sections.map((Section, idx) =>
                    <Section key={idx} data={langData} />
                )
            }
        </>
    );
};
export default HomeClient;